import React, { useState, useRef, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import "./commission-configuration.scss";
import { getAllMerchants } from "../../../../requests/merchantApi";
import { updateCommissionConfig } from "../../../../requests/comissionApi";
import { toast } from "react-toastify";

const RangeSlider = ({ label, value, setValue }) => {
  const rangeRef = useRef(null);
  const [thumbPosition, setThumbPosition] = useState(0);

  const handleChange = (e) => setValue(parseInt(e.target.value));

  useEffect(() => {
    if (rangeRef.current) {
      const rangeWidth = rangeRef.current.offsetWidth;
      const percentage = value / 100;
      setThumbPosition(rangeWidth * percentage);
      rangeRef.current.style.setProperty("--range-fill", `${value}%`);
    }
  }, [value]);

  return (
    <div className="range-input-slider">
      {label && <div className="name">{label}</div>}
      <div className="range-slider-wrap">
        <div
          className="tooltip"
          style={{ left: `calc(${thumbPosition}px - 15px)` }}
        >
          {value}%
        </div>
        <input
          ref={rangeRef}
          type="range"
          min="0"
          max="100"
          value={value}
          onChange={handleChange}
        />
      </div>
      <div className="percentage">e.g. 10%, 23%</div>
    </div>
  );
};

const UpdateCommissionConModal = ({ commission, fetchCommissionsList }) => {

  const [merchants, setMerchants] = useState([])
  const userFormik = useFormik({
    initialValues: {
      merchantID: "",
    },
    validationSchema: Yup.object({
      merchantID: Yup.string().required("Please enter merchant ID"),
    }),
    onSubmit: async (values) => {
      const payload = {
        merchant: values.merchantID,
        general,  tours, attractions, experiences, airportTransfers
      }
      const data = await updateCommissionConfig(commission._id, payload)
      if(data.status) {
        fetchCommissionsList()
        toast.success("Successfull updated")
      } else {
        toast.error(data.message)
      }
    },
  });

  const getAllMerchantsFun = async () => {
      const data = await getAllMerchants();
      if (data.status) {
        setMerchants(data.data);
      } else {
        toast.error(data.messgae)
      }
  };

  useEffect(() => {
    getAllMerchantsFun();
  }, []);

  useEffect(() => {
    if(commission) {
        userFormik.setFieldValue("merchantID", commission.merchant)
        setGeneral(commission.general)
        setTours(commission.tours)
        setAttractions(commission.attractions)
        setExperiences(commission.experiences)
        setAirportTransfers(commission.airportTransfers)

    }
  }, [commission])

  const [general, setGeneral] = useState(0);
  const [tours, setTours] = useState(0);
  const [attractions, setAttractions] = useState(0);
  const [experiences, setExperiences] = useState(0);
  const [airportTransfers, setAirportTransfers] = useState(0);
  return (
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content commission-configuration-modal">
        <div className="modal-body">
          <div className="modal-header">
            <h5 className="modal-title">Update Commission Configurations</h5>
            <img
              data-bs-dismiss="modal"
              aria-label="Close"
              src="/images/icons/close-circle.svg"
              alt="close-circle"
            />
          </div>

          <form className="commission-info" onSubmit={userFormik.handleSubmit}>
            <div className="commission-inputs">
              {/* <div className="floating-label percentage-input">
                <select
                  name="merchantID"
                  value={userFormik.values.merchantID}
                  onChange={userFormik.handleChange}
                  onBlur={userFormik.handleBlur}
                >
                  <option value="">Choose Merchant</option>
                  {merchants?.map((m) => (
                     <option value={m._id}>{m.fullName}</option>
                  ))}
                </select>
                <span>
                  <img src="/images/icons/search-icon-input.svg" alt="search" />
                </span>

                <label className="floating-label-text">Merchant ID</label>

                {userFormik.touched.merchantID &&
                  userFormik.errors.merchantID && (
                    <div className="error">{userFormik.errors.merchantID}</div>
                  )}
              </div> */}

              {/* Sliders */}
              <div className="modal-note">
                <h6>Seller Level Commission</h6>
                <p>
                  Teleport will deduct <b>{general}%</b> from each successful
                  sale.
                </p>
              </div>
              <RangeSlider value={general} setValue={setGeneral} />
              <div className="title-wrap">
                <h5>Category Commission</h5>
                <label className="toggle-switch">
                  <input type="checkbox" />
                  <span className="slider"></span>
                </label>
              </div>
              <RangeSlider label="Tours" value={tours} setValue={setTours} />
              <RangeSlider
                label="Attractions"
                value={attractions}
                setValue={setAttractions}
              />
              <RangeSlider
                label="Experiences"
                value={experiences}
                setValue={setExperiences}
              />
              <RangeSlider
                label="Airport Transfers"
                value={airportTransfers}
                setValue={setAirportTransfers}
              />
            </div>

            <div className="modal-footer">
              <button type="button" className="btn" data-bs-dismiss="modal">
                Cancel
              </button>
              <button type="submit" className="btn">
                Confirm
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateCommissionConModal;
